<template>
  <li class="d-flex border-bottom py-3 px-3 point-list">
    <div>{{date}}</div>
    <div>{{orderNo}}</div>
    <div class="text-right pr-5">{{getPoint}}</div>
    <div class="text-right pr-5">{{usePoint}}</div>
    <div>{{expiry}}</div>
    <div class="text-right pr-5">{{point}}</div>
  </li>
</template>
<script>
export default {
  props: ["History"],
  data(){
	return{
		date:'',
		orderNo:'',
		getPoint:'',
		usePoint:'',
		point:'',
		expiry:''
	}
  },
  mounted() {
	this.date = this.History['日付']
	this.orderNo = this.History['注文番号']
	this.getPoint = this.History['付与ポイント']
	this.usePoint = this.History['使用ポイント']
	this.point = this.History['残ポイント']
	this.expiry = this.History['有効期限年月日']
	console.log('HIstory')
	console.log(this.History)
  },
}
</script>
<style scoped>
.point-list div {
  width: 17%;
}
</style>